import React, { Fragment } from 'react';
import PropTypes from 'proptypes';

const InsuranceModal = ({ closeModal, mailingCountry }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <h3>INTERNATIONAL TRAVEL INSURANCE</h3>
    <p>
      Since unexpected events can happen while traveling, GIVE requires all travelers to obtain and 
      provide proof of International Travel Insurance that includes medical coverage, trip cancellation, 
      and trip interruption. Travelers Insurance will put your mind at ease so you can focus on your 
      GIVE trip should an unexpected event occur, like flight delays. We strongly recommend purchasing 
      Travelers Insurance early to receive the full coverage benefits. You can purchase insurance before 
      booking your flights, then easily modify your coverage amount to include your airfare costs.
    </p>
    {mailingCountry === 'United States' ? (
      <Fragment>
        <h4>GENERALI TRAVEL INSURANCE</h4>
        <p>
          Click the “PURCHASE YOUR INSURANCE” link to obtain a quote.
        </p>
        <ul>
          <li>
          Important Notes: Coverage dates = Your “policy duration” must include all travel days. 
          Your insurance Start Date is the day your leave home and End Date is the day you return home. 
          We recommend insuring your total GIVE trip cost after reserving your spot 
          (the sooner, the better), then increasing your coverage amount after you book your flights.
          </li>
        </ul>
        <a 
          href="https://go.givevolunteers.org/getinsurance" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          PURCHASE YOUR INSURANCE
        </a>
        <p>
        Please note you can add Trip Cancellation For Any Reason Coverage, which provides coverage
        if you choose to cancel your trip for any reason not already listed in the policy. In order 
        to qualify for this option, you must purchase this coverage within 24 hours of your deposit/initial 
        payment and meet certain conditions listed in the Description of Coverage or Policy. 
        Note that Trip Cancellation For Any Reason Coverage is not available to residents of New York.
        </p>
      </Fragment>
    ) : (
      <Fragment>
        <p>
          There are different providers based on your country of residence that offer comprehensive plans, such 
          as Generali, Allianz, Travel Guard, and CoverMore. Click below and select your relevant location to review 
          our minimum coverage requirements.
        </p>
        <a 
          href="https://go.givevolunteers.org/getinsurance2" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          EXPLORE TRAVELERS INSURANCE
        </a>
        <h5>
          <strong>Important Note**</strong>
        </h5>
        <p>
          Coverage dates = Your “policy duration” must include all travel days. Your insurance Start Date is the day 
          your leave home and End Date is the day you return home. We recommend insuring your total GIVE trip cost after 
          reserving your spot, then increasing your coverage amount after you book your flights.
        </p>
        <a
          href="https://go.givevolunteers.org/getinsurance2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Purchase your travelers insurance (this is different than health insurance).
        </a>{' '}
      </Fragment>
    )}
  </div>
);

InsuranceModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  mailingCountry: PropTypes.string.isRequired,
};

export default InsuranceModal;
